import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateJuzgadoRequest } from '@models/juzgado/createJuzgadoResquest.model';
import { JuzgadoDto } from '@models/juzgado/juzgadoDto.model';
import { JuzgadoFilter } from '@models/juzgado/juzgadoFilter.model';
import { UpdateJuzgadoRequest } from '@models/juzgado/updateJuzgadoResquest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class JuzgadoService {

  constructor(
    private http:HttpClient
  ) { }

  create(createJuzgadoRequest:CreateJuzgadoRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/Juzgado/Create",createJuzgadoRequest);
  }

  update(updateJuzgadoRequest:UpdateJuzgadoRequest):Observable<any>
  {
    return  this.http.put<any>("/api/Juzgado/Update",updateJuzgadoRequest);
  }

  getAll():Observable<JuzgadoDto[]> {
    return   this.http.get<JuzgadoDto[]>("/api/Juzgado/GetAll");
  }

  getAllByIdLocalidad(idLocalidad:number):Observable<JuzgadoDto[]> {
    return   this.http.get<JuzgadoDto[]>("/api/Juzgado/GetAllByIdLocalidad?idLocalidad="+idLocalidad);
  }

  getAllByFilter(juzgadoFilter: JuzgadoFilter): Observable<JuzgadoDto[]> {
      return this.http.post<JuzgadoDto[]>("/api/Juzgado/GetAllByFilter", juzgadoFilter);
    }

  getById(id:number):Observable<JuzgadoDto>{
    return  this.http.get<JuzgadoDto>("/api/Juzgado/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/Juzgado/Delete?id=" + id);
    else
      return of(null)
  }
}
